import * as React from 'react';
import type { SVGProps } from 'react';
import { chakra } from '@chakra-ui/react';
const SvgIconMarketSg = chakra((props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={22}
    height={20}
    fill="none"
    viewBox="0 0 22 20"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="url(#icon-market-sg_svg__a)"
      d="M21 4.14c.703 1.094.781 2.462.234 3.673-.507 1.093-1.523 1.875-2.734 2.03-.195 0-.39.04-.547.04-.86 0-1.64-.274-2.344-.742-1.328.937-3.28.937-4.648 0-1.328.937-3.281.937-4.61 0a3.858 3.858 0 0 1-2.226.703c-.04 0-.078.039-.117.039-.196 0-.352-.04-.547-.04-1.211-.155-2.227-.937-2.734-2.03C.18 6.601.257 5.233.96 4.14L2.992.937A1.917 1.917 0 0 1 4.632 0h12.696c.664 0 1.29.352 1.64.938L21 4.14Zm-1.445 2.852a1.919 1.919 0 0 0-.117-1.836l-2.032-3.242-12.773-.039-2.11 3.281a1.919 1.919 0 0 0-.117 1.836c.274.547.742.899 1.29.977.702.078 1.445-.157 1.952-.703l.704-.782.664.782c.859.937 2.421.937 3.28 0l.665-.782.703.782c.86.937 2.422.937 3.242 0l.703-.743.704.743c.507.546 1.25.78 1.953.703.547-.078 1.015-.43 1.289-.977Zm-1.602 4.14c.235 0 .469-.038.703-.077.352-.078.742-.157 1.055-.274v7.031c0 1.211-.977 2.188-2.188 2.188H4.438a2.184 2.184 0 0 1-2.188-2.188v-7.03c.313.155.664.234 1.055.312.234 0 .468.039.703.039.039 0 .078-.04.117-.04v2.032h13.71v-2.031c.04 0 .08.039.118.039Zm-.43 6.993c.196 0 .313-.117.313-.313V15H4.125v2.813c0 .195.117.312.313.312h13.085Z"
      opacity={0.6}
    />
    <defs>
      <linearGradient
        id="icon-market-sg_svg__a"
        x1={22.5}
        x2={2.694}
        y1={-0.5}
        y2={22.277}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset={0.18} stopColor="#EEE" />
        <stop offset={0.73} stopColor="#A0A0A0" />
        <stop offset={1} stopColor="#979797" />
      </linearGradient>
    </defs>
  </svg>
));
export default SvgIconMarketSg;
